import { useContext, useEffect, useState } from 'react';
import { 
    Box, Card, CardContent, CardMedia, IconButton, Typography, FormControl, Grid, InputLabel, OutlinedInput, InputAdornment,
    Button, TextField, Modal
} from '@mui/material';
import { MyContext } from '../MyContext';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import noImage from '../images/noimage.png';
import Helpers from "../Helpers";

const docHeigth = window.innerHeight;
const docWidth = window.innerWidth;

const styles = {
    card: {
        width: (docWidth > 420) ? 320 : '48%',
        height: 'auto',
        display: 'flex', 
        flexDirection: 'column',
        marginBottom: 8,
    },
    box_media: {
        width: '100%',
        height: 160, // altura fixa ou adaptável
        paddingTop: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden', // corta o excesso
        position: 'relative',
    },
    img_media: {
        width: '100%',
        height: '100%',
        objectFit: 'contain', // mantém a proporção sem cortar
        objectPosition: 'center', // centraliza
    },
    cod_produto: {
        position: 'absolute', // 👈 faz o texto flutuar sobre a imagem
        top: 5,               // distância do topo
        left: 5,              // distância da esquerda
        fontSize: 12,
        fontStyle: 'italic',
        backgroundColor: 'rgba(0,0,0, .6)',
        color: '#F5F5F5',
        padding: '2px 6px',   // 👌 um espacinho pro texto respirar
        borderRadius: 4,
        zIndex: 9,            // garante que fica acima da imagem
    },
    box_info: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',        
    },
    box_content: {
        flex: '1 0 auto',
        width: '100%',
        flexWrap: 'wrap',
    },
    nm_prod: {
        width: '100% !important',
        height: 42,
        fontSize: (docWidth > 420) ? 13 : 11,
        fontWeight: 'bold',
    },
    formInput: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
    },
    formInputValor: {
        width: '100%',
        fontSize: (docWidth > 420) ? 26 : 22,
        fontWeight: 'bold',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'baseline',
        gap: 3,
        marginTop: '2%',
        backgroundColor: '#f5f5f5',
    },
    formInputUnit: {
        fontSize: 12,
        fontStyle: 'italic',
    },
    formInputQtde: {
        backgroundColor: '#FFF',
        width: '49%',
        float: 'left',
    },
    boxFooter: {
        marginTop: '2%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalHeader: {
        width: (docWidth > 420) ? 380 : 340,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '3px solid #DA0C16'
    },
    headerTitle: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
    },
    modalCodProduto: { 
        fontSize: 12,
        fontStyle: 'italic',
        backgroundColor: 'rgba(0,0,0, .6)',
        color: '#F5F5F5',
        padding: '2px 6px',
        borderRadius: 4,
    },
    modalNmProduto: {
        fontSize: 14,
        fontWeight: 'bold',
    },
    btnCloseModal: {
        justifyContent: 'flex-end',
        color: '#DA0C16',
    },
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: (docWidth > 420) ? 400 : '90%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 1,
};

function CardProduto({ produto }){
    const { listaCarrinho, setListaCarrinho } = useContext(MyContext);
    const [imgProduto, setImgProduto] = useState(null);
    const [qtdeProduto, setQtdeProduto] = useState(1);
    const [obsProduto, setObsProduto] = useState('');
    const [itemSelecionado, setItemSelecionado] = useState(null);

    useEffect(()=>{
        renderImage(produto);
        setQtdeProduto(produto.qtProduto);
        setObsProduto(produto.dsObs); 
    }, [produto]);

    useEffect(() => {
        produtoSelecionado(itemSelecionado, qtdeProduto, obsProduto);
    }, [listaCarrinho]);

    const handleOpenModal = (item) => {
        setItemSelecionado(item)
    };

    const handleCloseModal = () => {
        setItemSelecionado(null);
    };

    const renderImage = (item)=>{
        let newImg = item.cmImagem;

        if(newImg !== null){
            setImgProduto(newImg);
        }else{
            setImgProduto(noImage);
        }
    };

    const abrilModalProduto = (produto) => {
        const existe = produto.adicionado;

        const buttonStyle = existe ? {
            width: '100%',
            border: '1px solid green',
            backgroundColor: 'green',
            color: '#F5F5F5',
            fontWeight: 'bold'
        } : {
            width: '100%',
            border: '1px solid green',
            backgroundColor: 'transparent',
            color: 'green',
            fontWeight: 'bold'
        };

        const Icon = existe ? ShoppingCartCheckoutIcon : AddShoppingCartIcon;
        const texto = existe ? 'atualizar' : 'adicionar';

        return (
            <Button onClick={()=>handleOpenModal(produto)} startIcon={<Icon />} style={buttonStyle} >
                {texto}
            </Button>
        );
    };

    const handleInputChange = (value) => {
        const empresa = JSON.parse(localStorage.getItem('empresa') ?? '{}');
        const usarInputFloat = empresa.usarInputFloat;
        const qtDisponivel = produto.ctrEstoqProdutoWeb ? 999.999 : Math.max(0, Number(produto.qtProdutoDisponivel) || '');
        const result = Helpers.sanitizeQuantidade(value, usarInputFloat, produto.ctrEstoqProdutoWeb, qtDisponivel);

        setQtdeProduto(result.raw);
    };

    const produtoSelecionado = (produto, quantidade, ds_obs) => {
        const existe = produto?.adicionado ?? false;

        const buttonStyle = existe ? {
            width: '100%',
            border: '1px solid green',
            backgroundColor: 'green',
            color: '#F5F5F5',
            fontWeight: 'bold'
        } : {
            width: '100%',
            border: '1px solid green',
            backgroundColor: 'transparent',
            color: 'green',
            fontWeight: 'bold'
        };

        const Icon = existe ? ShoppingCartCheckoutIcon : AddShoppingCartIcon;
        const texto = existe ? 'atualizar' : 'adicionar';

        return (
            <Button
                onClick={() => adicionarProdutoSqLite(produto, quantidade, ds_obs)}
                startIcon={<Icon />}
                style={buttonStyle}
                sx={{ mt: 2 }}
            >
                {texto}
            </Button>
        );
    };

    const adicionarProdutoSqLite = (produto, quantidade, ds_obs) => {
        if(quantidade <= 0 || quantidade === ''){
            Helpers.toastAlert({
                title: "Informe a quantidade do produto para prosseguir",
                icon: "warning",
            }); 

            return true;
        }

        let qtde = quantidade;
        setQtdeProduto(qtde);
        setObsProduto(ds_obs);

        const novoProduto = {
            idCliente: produto.idCliente,
            idProduto: produto.idProduto,
            nmProduto: produto.nmProduto,
            dsUnidade: produto.dsUnidade,
            qtProdutoDisponivel: produto.qtProdutoDisponivel,
            ctrEstoqProdutoWeb: produto.ctrEstoqProdutoWeb,
            vrProduto: produto.vrProduto,
            vr_unitario: produto.vr_unitario,
            valor_final: produto.valor_final,
            valor_base: produto.valor_base,
            vr_custo: produto.vr_custo,
            vr_custofp: produto.vr_custofp,
            valor_st: produto.valor_st,
            vr_mva: produto.vr_mva,
            vr_aliquotaicms: produto.vr_aliquotaicms,
            vr_aliquotaicmsst: produto.vr_aliquotaicmsst,
            vr_redubaseicms: produto.vr_redubaseicms,
            vr_alqpobreza: produto.vr_alqpobreza,
            alqpobreza: produto.alqpobreza,
            vbcfcpst: produto.vbcfcpst,
            ds_modalbcicmsst: produto.ds_modalbcicmsst,
            id_cfop: produto.id_cfop,
            id_almoxarifado: produto.id_almoxarifado,
            id_cst: produto.id_cst,
            id_cstipi: produto.id_cstipi,
            id_csosn: produto.id_csosn,
            id_estoqueprod: produto.id_estoqueprod,
            id_cstpis: produto.id_cstpis,
            id_cstcofins: produto.id_cstcofins,
            id_origemprodnfe: produto.id_origemprodnfe,
            id_nbm: produto.id_nbm,
            id_operacaofiscal: produto.id_operacaofiscal,
            id_enquadraipi: produto.id_enquadraipi,
            id_cest: produto.id_cest,
            qtProduto: qtde,
            dsObs: ds_obs,
        };

        const prods = localStorage.getItem('carrinhoProdutos');
        let novosProdutos = [];

        if (prods) {
            const arrayProds = JSON.parse(prods);
            const filtrado = arrayProds.filter(p => p.idProduto !== produto.idProduto);
            novosProdutos = [...filtrado, novoProduto];
        } else {
            novosProdutos = [novoProduto];
        }

        // Atualiza o localStorage
        localStorage.setItem('carrinhoProdutos', JSON.stringify(novosProdutos));

        // 🚀 Atualiza o contexto para refletir na tela
        setListaCarrinho(novosProdutos);
        handleCloseModal();

        Helpers.toastAlert({
            title: "Produto adicionado ao carrinho.",
            icon: "success",
        });
    };

    return (
        <>
        <Card style={styles.card}>
            <Box style={styles.box_media}>
                <Typography component="div" style={styles.cod_produto}> {`Cod: ${produto.cdProduto}`} </Typography>
                <CardMedia
                    component="img"
                    image={imgProduto}
                    alt={produto.nmProduto}
                    style={styles.img_media}
                />
            </Box>
            <Box style={styles.box_info}>
                <CardContent style={styles.box_content}>
                    <Typography component="div" style={styles.nm_prod}> {produto.nmProduto}</Typography>
                    
                    <Box style={styles.formInput}>
                        <Typography variant="h4" style={styles.formInputValor}> 
                            R$ { (produto.vrProduto).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) } 
                        {
                            (produto.ds_unidade !== '') &&
                            <Typography style={styles.formInputUnit}>{produto.dsUnidade}</Typography>
                        }
                        </Typography>
                    </Box>

                    <Box style={styles.boxFooter}>
                    {
                        // (produto.ctrEstoqProdutoWeb || produto.ctrEstoqMinimoWeb)
                        (produto.ctrEstoqProdutoWeb)
                        ? (
                            <Typography variant="subtitle1" component="div" sx={{ color: '#DA0C16', fontSize: 12, fontStyle: 'italic' }} > 
                                Produto indisponível
                            </Typography>
                        )
                        : abrilModalProduto(produto)
                    }
                    </Box>
                </CardContent>
            </Box>
        </Card>

        <Modal open={!!itemSelecionado} onClose={handleCloseModal}>
            <Box sx={style}>
                <Box sx={styles.modalHeader}>
                    <Box sx={styles.headerTitle}>
                        <Typography component="div" style={styles.modalCodProduto}> {`Cod: ${produto.cdProduto}`} </Typography>
                        <Typography style={styles.modalNmProduto}>{itemSelecionado?.nmProduto}</Typography>
                    </Box>

                    <Button onClick={()=>handleCloseModal()} startIcon={<HighlightOffIcon />} style={styles.btnCloseModal} />
                </Box>
                <Box sx={{ mt: 2 }}>
                    <FormControl size='small' variant="outlined" style={styles.formInputQtde}>
                        <InputLabel htmlFor="outlined-adornment-password">Quantidade</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={'text'}
                            value={qtdeProduto}
                            onChange={(e) => handleInputChange(e.target.value)}
                            label="Quantidade"
                            /*startAdornment={
                                <InputAdornment position="start">
                                    <IconButton
                                        onClick={handleDecrement}
                                        edge="start"
                                    >
                                        <RemoveCircleIcon />
                                    </IconButton>
                                </InputAdornment>
                            }*/
                            /*endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleIncrement}
                                        edge="end"
                                    >
                                        <AddCircleIcon />
                                    </IconButton>
                                </InputAdornment>
                            }*/
                        />
                    </FormControl>

                    {
                        (!produto.ctrEstoqProdutoWeb && (produto.qtProdutoDisponivel > 0)) &&   
                        <TextField
                            id="outlined-multiline-static2"
                            label={`Em estoque`}
                            defaultValue={produto.qtProdutoDisponivel}
                            slotProps={{ htmlInput: { maxLength: 150 }, inputLabel: { shrink: true } }}
                            size='small'
                            disabled
                            sx={{ width: '49%', float: 'right' }}
                        />
                    }

                    <TextField
                        id="outlined-multiline-static"
                        label={`Observação (${obsProduto.length}/150)`}
                        defaultValue={obsProduto}
                        onChange={(e) => setObsProduto(Helpers.maxLenght(e.target.value, 150))}
                        multiline
                        fullWidth 
                        rows={4}
                        sx={{ mt: 2 }}
                        slotProps={{ htmlInput: { maxLength: 150 }, inputLabel: { shrink: true } }}
                    />

                    { produtoSelecionado(itemSelecionado, qtdeProduto, obsProduto) }
                </Box>
            </Box>
        </Modal>
        </>
    );
}

export default CardProduto;;